import { Injectable, inject } from "@angular/core";
import { ITaskTab, TaskService } from "../api-generated";
import BaseService from "./base.service";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export default class LocalTaskService extends BaseService<ITaskTab> {
  taskService = inject(TaskService);

  constructor() {
    super();
    this.itemsSubject.next([]);
  }

  protected loadingSubject = new BehaviorSubject<boolean>(false);
  
  loading$: Observable<boolean> = this.loadingSubject.asObservable();

  fetchData() {
    this.loadingSubject.next(true);
    this.taskService.getTasks().subscribe(data => {
      this.loadingSubject.next(false);
      this.itemsSubject.next(data);
    });
  }
}
